function organismeToString(organisme) {
    if (organisme === null || organisme === undefined) return ''

    const str =
        organisme.regime +
        organisme.caisse +
        organisme.centre

    return str
}

function stringToOrganisme(str) {
    str = str.replace(/\s/g, '')

    const organisme = {
        regime: str.substring(0, 2),
        caisse: str.substring(2, 5),
        centre: str.substring(5, 9),
    }

    return organisme
}

export {
    organismeToString,
    stringToOrganisme
}
